// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { MDBBtn, MDBCol, MDBInput, MDBRow } from "mdbreact";

const ContractorTasks = ({ section, tasks, handler, isAssigned }) => {
    if (!tasks[section] || tasks[section].length === 0) return null;
    const changeTasksStatus = (section, tasks, handler, id, value) => {
        handler({
            ...tasks,
            [section]: [
                ...tasks[section].reduce((acc, el) => {
                    if (el.index === Number(id)) {
                        acc.push({ ...el, checked: value });
                        return acc
                    }
                    acc.push(el);
                    return acc
                }, []),

            ]
        })
    }
    return (
        <MDBRow style={{ marginBottom: "0px", textAlign: "left" }}>
            <MDBCol>
                <MDBRow>
                    <hr className="my-4 hrline2" />
                </MDBRow>

                <div className="wo-task-checklist">
                    {tasks[section].sort((a, b) => a.index - b.index).map(task => (
                        <label
                            key={`${section}-${task.index}`}
                            className="wo-check-btn check_btn wo-task-check"
                        >
                            <input
                                type="checkbox"
                                disabled={!isAssigned}
                                className="task-required"
                                id={task.index + section}
                                checked={task.checked}
                                onChange={(e) => changeTasksStatus(section, tasks, handler, task.index, e.target.checked)}
                            />
                            <span>{task.name}</span>
                        </label>
                    ))}
                </div>
            </MDBCol>
        </MDBRow>
    );
};

export default ContractorTasks;
